import { durationStringToMinutes } from '@vendasta/meetings';
import { formatMinutesLabel } from '../util';

export function durationMinutes(duration: string): string {
  if (!duration) {
    return '';
  }
  return formatMinutesLabel(durationStringToMinutes({ duration }));
}
